export class FaturamentoModel {
    valor_parcela?: number
    valor_pago?: number
    vencimento?: Date
    data_pagamento?: Date
    emissao?: Date
    boleto?: string
    status?: string
    cliente?: string
    endereco?: string
    numero?: string
    tipo_pagamento?: string

    origem?: string
    valor_nf?: number
    coligada?:string
    parcela?: string

    valor?:string
    valor_chart?:number
    perc_valor?:string
    perc_parcelas?:string 

    filtro_data_inicial:Date
    filtro_data_final:Date
}